import React from 'react';
import { Link } from 'react-router-dom';
import './BengaliReviews.css';
import { englishMovies } from './movieData';

function EnglishReviews() {
  return (
    <div className="content background1 shadow p-3 rounded row">
      {englishMovies.map((movie) => (
        <div className="card col-sm-6 col-md-4 col-lg-3 mb-3 m-4" key={movie.title}>
          <div className="card__image-container"><img className="card__image img-fluid" src={movie.imageUrl} alt={movie.title} /></div>
          <div className="card__content"><h6 className="card__title">{movie.title}</h6><p className="card-text">{movie.content}</p></div>
          <Link to={`/Reviews/${movie.title}`} className="bottom-button reviewButton"><b>Read Reviews</b></Link>
        </div>
      ))}
    </div>
  );
}

export default EnglishReviews;
